import { useMemo } from 'react'
import { TYPEAHEAD_NOSPACE_SEARCH_ROLLOUT_FLAGS, TYPEAHEAD_REALTIME_EXTRACTION_ROLLOUT_FLAGS } from 'constants/search'
import { EmptyArray } from 'lib/array/arrayUtils'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

/**
 * Builds the typeahead rollout flags array from the feature flags that
 * gate real-time extraction and no-space search. Reads Optimizely flags
 * internally so callers don't need to manage them. Returns a stable
 * EmptyArray reference when no flags are active.
 */
function useTypeaheadRollout(): Array<string> {
  const isRealTimeDateAndOccupancyExtractionEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.searchRealTimeDateAndOccupancyExtraction)
  const isTypeaheadNospaceMatchEnabled = !!useOptimizelyExperiment(OptimizelyFeatureFlags.searchTypeaheadNospaceMatch)

  return useMemo(() => {
    const flags: Array<string> = [
      ...(isRealTimeDateAndOccupancyExtractionEnabled ? TYPEAHEAD_REALTIME_EXTRACTION_ROLLOUT_FLAGS : []),
      ...(isTypeaheadNospaceMatchEnabled ? TYPEAHEAD_NOSPACE_SEARCH_ROLLOUT_FLAGS : []),
    ]
    return flags.length > 0 ? flags : EmptyArray
  }, [isRealTimeDateAndOccupancyExtractionEnabled, isTypeaheadNospaceMatchEnabled])
}

export default useTypeaheadRollout
